import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/session';

/**
 * セッション管理のState型
 */
export interface ISessionState {
	/** ログインID */
	readonly loginID: string;
	/** トークン */
	readonly token: string;
	/** ユーザ情報 */
	readonly userAttr: Actions.IUserAttr;
}

const initialUserAttr: Actions.IUserAttr = {
	authorityList: [],
	lang: '',
	locale: '',
	loginType: '',
	managerChk: '',
	userFamilyName: '',
	userId: '',
	userName: '',
};

/**
 * セッション管理のState初期値
 */
const initialState: ISessionState = {
	loginID: localStorage.loginID || '',
	token: localStorage.token || '',
	userAttr: localStorage.userAttr
		? JSON.parse(localStorage.userAttr)
		: initialUserAttr,
};

/**
 * セッション管理用reducer
 * @param state State
 * @param action アクション
 */
const session = (state: ISessionState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	if (isType(action, Actions.setSessionLoginID)) {
		localStorage.setItem('loginID', action.payload.loginID);
		return {
			...state,
			loginID: action.payload.loginID,
		};
	}

	if (isType(action, Actions.setSessionToken)) {
		localStorage.setItem('token', action.payload.token);
		return {
			...state,
			token: action.payload.token,
		};
	}

	if (isType(action, Actions.setSessionUserAttr)) {
		localStorage.setItem(
			'userAttr',
			JSON.stringify(action.payload.userAttr)
		);
		return {
			...state,
			userAttr: action.payload.userAttr,
		};
	}

	if (isType(action, Actions.clearSession)) {
		localStorage.removeItem('loginID');
		localStorage.removeItem('token');
		localStorage.removeItem('userAttr');
		return initialState;
	}

	return state;
};

export default session;



// WEBPACK FOOTER //
// ./src/reducers/session.ts